<script lang="ts">
	import Main from "../../organisms/recruitments/New.svelte";
</script>

<div class="flex">
	<div class="flex-1">
		<Main/>
	</div>
</div>